import { z } from 'zod';
import dayjs from 'dayjs';

enum NET_ZERO_MODAL_MESSAGE {
  BASE_YEAR = 'กรุณาเลือกปีฐาน',
  QUANTITY = 'กรุณาระบุจำนวน',
  REQUIRED = 'กรุณาเลือก',
  PERCENT_INVALID = 'จำนวนไม่ถูกต้อง',
}

export const NetZeroModalSchema = z
  .object({
    scopeId: z.number(),
    baseYear: z.object({
      year: z.custom((value) => dayjs.isDayjs(value) && value.isValid(), {
        message: NET_ZERO_MODAL_MESSAGE.BASE_YEAR,
      }),
      gasEmissionQuantity: z.union([
        z.string({ message: NET_ZERO_MODAL_MESSAGE.QUANTITY }).min(1, {
          message: NET_ZERO_MODAL_MESSAGE.QUANTITY,
        }),
        z.number({ message: NET_ZERO_MODAL_MESSAGE.QUANTITY }),
      ]),
    }),
    nearTermTarget: z.object({
      gasEmissionPercent: z
        .union([z.string().transform((value) => Number(value)), z.number()])
        .refine((value) => value >= 0 && value <= 100, {
          message: NET_ZERO_MODAL_MESSAGE.PERCENT_INVALID,
        })
        .optional()
        .nullable(),
      gasEmissionQuantity: z
        .union([z.string().transform((value) => Number(value)), z.number()])
        .optional()
        .nullable(),
    }),
    longTermTarget: z.object({
      gasEmissionPercent: z
        .union([z.string().transform((value) => Number(value)), z.number()])
        .transform((value) => Number(value))
        .refine((value) => value >= 0 && value <= 100, {
          message: NET_ZERO_MODAL_MESSAGE.PERCENT_INVALID,
        })
        .optional()
        .nullable(),
      gasEmissionQuantity: z
        .union([z.string().transform((value) => Number(value)), z.number()])
        .optional()
        .nullable(),
    }),
    isTgo: z.union([z.string(), z.boolean()]),
    tgoId: z.union([z.string(), z.number()]).optional(),
    isSbti: z.union([z.string(), z.boolean()]),
    sbtiId: z.union([z.string(), z.number()]).optional(),
  })
  .superRefine((data, ctx) => {
    if (data.isTgo === 'true' && data.tgoId === '') {
      ctx.addIssue({
        code: 'custom',
        path: ['tgoId'],
        message: NET_ZERO_MODAL_MESSAGE.REQUIRED,
      });
    }

    if (data.isSbti === 'true' && data.sbtiId === '') {
      ctx.addIssue({
        code: 'custom',
        path: ['sbtiId'],
        message: NET_ZERO_MODAL_MESSAGE.REQUIRED,
      });
    }
  });
